import React from "react";
import { Container, SlideContainer, TestminonialWrapper } from "./styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ellipse5 from "assets/ellipse5.png";
import ellipse6 from "assets/ellipse6.png";
import anu_photo from "assets/anu.jpeg";
import fikayo_photo from "assets/fikayo.jpeg";
import { react_slick_settings } from "component/utils";


const default_testimonies = [
  {
    name: "Anu",
    country: "Canada",
    school: "",
    img: anu_photo,
    testimony:
      "The Schooliply team is such a vibrant and professional team. They assisted me with my study abroad resources and admission. I was able to gain admission and eventually my Visa to Canada. I will recommend them any day any time for sure."
  },
  {
    name: "Fikayo",
    country: "Canada",
    school: "",
    img: fikayo_photo,
    testimony:
      "You can trust Schooliply to take care of your study admission needs for sure."
  }
];

function Index({ fontColor, title_tip, title, bg, testimonies = default_testimonies }) {

  return (
    <Container bg={bg} fontColor={fontColor}>
      <img src={ellipse6} className="ellipse6" alt="ellipse" />
      <div className="wrapper">
        <div className="header">
          <span>{title_tip}</span>
          <p className="title">{title}</p>
        </div>
        <SlideContainer>
          <div className="slide-container">
            <Slider {...react_slick_settings}>
              {testimonies?.map(({ name, country, school, img, testimony }, index) => {
                return (
                  <TestminonialWrapper key={testimony + index}>
                    <div className="testimonial-wrap">
                      <div className="testimony-wrap">
                        <p className="testimonial-text">{testimony}</p>
                        <div className="person-deets">
                          <img src={img} alt="img" />
                          <div className="name-country">
                            <p>
                              {name}, {country}
                            </p>
                            <p>{school}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TestminonialWrapper>
                );
              })}
            </Slider>
          </div>
        </SlideContainer>
      </div>
      <img src={ellipse5} className="ellipse5" alt="ellipse" />
    </Container>
  );
}

export default Index;
